import { isNumber } from './isNumber';

export function toNumber(value: unknown): number | null {
  if (isNumber(value)) {
    return value;
  }
  if (typeof value === 'string') {
    const parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : null;
  }
  return null;
}
